const currencies = [
  { t: 'Euro', v: 'EUR' },
];

export default currencies;
